import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { logError } from "../lib/log";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { adoptSession } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace("#", "?")).get("session_id");
    (async () => {
      try {
        // The session token is stored by the backend in an httpOnly cookie.
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        adoptSession(data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (error) {
        logError("Google sign-in exchange failed", error);
        navigate("/login", { replace: true });
      }
    })();
    // Runs exactly once: the session_id is single-use and we navigate away immediately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div className="py-40 text-center text-slate-500 text-sm">Completing sign in…</div>;
}
